<template>
  <div class="c-modal">
    <div class="c-modal__window" v-click-outside="onClickOutside">
      <div class="c-modal__inner">
        <header class="c-modal__header" :class="{ 'is-full': fullHeader }">
          <slot name="header"></slot>
          <base-button
            v-if="showCloseButton"
            class="c-modal__close"
            @click="closeModal"
            :ghost="true"
          >
            <icon name="cross"></icon>
          </base-button>
        </header>
        <section v-if="media" class="c-modal__media">
          <slot name="media"></slot>
        </section>
        <section v-if="$slots.default" class="c-modal__content">
          <h2 v-if="title">{{ title }}</h2>
          <p v-if="text">{{ text }}</p>
          <slot></slot>
        </section>
        <footer v-if="$slots.footer" class="c-modal__footer">
          <slot name="footer"></slot>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";

export default {
  name: "modal",

  props: {
    media: null,
    title: String,
    text: String,
    outsideClose: null,
    showCloseButton: Boolean,
    fullHeader: Boolean
  },

  mounted() {
    document.querySelector("body").classList.add("noscroll");
  },

  methods: {
    onClickOutside() {
      if (this.outsideClose) {
        this.closeModal();
      }
    },

    closeModal() {
      document.querySelector("body").classList.remove("noscroll");
      this.$emit("close");
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>

<style lang="scss">
.c-modal {
  background: rgba(32, 32, 32, 0.6);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 80;
  // overflow:scroll;

  &__window {
    background: $colour-nhs-white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 600px;
    border-radius: 4px;
    box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.2);
    // overflow: hidden;
    z-index: 90;
    max-width: 90vw;
    max-height: 90vh;
    overflow: scroll;
  }

  &__header {
    // outline: 2px solid red;
    padding: 0.25em 2em;
    position: relative;
    border-bottom: 1px solid tint($colour-nhs-dark-grey, 20);

    &.is-full {
      padding: 0;

      img {
        max-width: 100%;
      }

      .c-modal__close {
        height: auto;
      }
    }
  }

  &__close {
    position: absolute;
    top: 0;
    right: 0;
    padding-right: 2em;
    height: 100%;
  }

  &__media {
    background: #eaeaea;
    min-height: 200px;
  }

  &__content {
    min-height: 300px;
    padding: 1em 2em 2em;
    // outline: 2px solid green;
  }

  &__footer {
    border-top: 1px solid tint($colour-nhs-dark-grey, 20);
    padding: 2em;
  }
}
</style>
